import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=45a18690&scoped=true&"
import script from "./add-product.vue?vue&type=script&lang=js&"
export * from "./add-product.vue?vue&type=script&lang=js&"
import style0 from "./add-product.vue?vue&type=style&index=0&id=45a18690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a18690",
  null
  
)

export default component.exports